import { observer } from 'mobx-react';
import { useStore } from '../../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
// import { toJS } from 'mobx';
// import { TextField } from '@mui/material';
// import InputAdornment from "@mui/material/InputAdornment";
// import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ExchangePage from './ExchangePage';












function CoinExchangePropose() {
  const { loginStore } = useStore();
  // const { SaleStore } = useStore();
  const { CoinExchangeStore } = useStore();
  // const { CoinStore } = useStore();


  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '500px',
      height: "500px",
      // minHeight: "25rem",
      minHeight: "auto",
      // backgroundColor:"#212121"

    },
    DialogMobile: {
      height: '100%',
      width: '100%',
      minWidth: "320px",
      padding: '0'
    },
    //CategoryImage
    CategoryImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '10rem',
      height: "5rem"
    },
    //CategoryImage
    BrandImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '12rem',
      height: "12rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // let Clover_sale_count = SaleStore?.sale_clover_Token;

  // let User_Clover_Count = loginStore.CloverCount;
  let isCoinExchangeProposeDialogOpen = loginStore?.isCoinExchangeProposeDialogOpen;
  // let ErrorGuide_clover_page_userBar_01 = loginStore?.ErrorGuide_clover_page_userBar_01; //복사에 실패하였습니다
  // let Guide_clover_page_userBar_01 = loginStore?.Guide_clover_page_userBar_01; //복사 하였습니다


  // Guide_clover_dialog_ExchangePage_01
  // const Wallet = "0x53e1dd84f89e680d2920ca1bbe128e829452e6b2";


  // let ProductListTable = toJS(SaleStore.ProductList);// item list

  // let BrandTable = toJS(SaleStore.BrandTable);
  // let CategoryTable = toJS(SaleStore.CategoryTable);


  let isBTC = CoinExchangeStore?.isBTCOpen;
  let isUSTD = CoinExchangeStore?.isUSTDOpen;
  // let BrandChack = String(SaleStore.market_brand_chack);


  // console.log(CategoryTable);
  // console.log(BrandChack);


  // const copy = async (text) => {
  //   // console.log(text);
  //   if (text === undefined || text === null || text === "") {
  //     return alert(ErrorGuide_clover_page_userBar_01);
  //   }
  //   else {
  //     try {
  //       await navigator.clipboard.writeText(text);
  //       return alert(Guide_clover_page_userBar_01);
  //     } catch (error) {
  //       // console.log(error);
  //       return alert(ErrorGuide_clover_page_userBar_01);
  //     }
  //   }
  // }

  // const WalletTextField = ({ iconStart, iconEnd, InputProps, ...props }) => {
  //   return (
  //     <TextField
  //       fullWidth
  //       variant="standard"
  //       {...props}
  //       inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 7.7 } } : { min: 0, style: { textAlign: 'center', fontSize: 14, } }}
  //       InputProps={{
  //         ...InputProps,
  //         startAdornment: iconStart ? (
  //           <InputAdornment position="start">{iconStart}</InputAdornment>
  //         ) : null,
  //         endAdornment: iconEnd ? (
  //           <InputAdornment position="end">{iconEnd}</InputAdornment>
  //         ) : null,
  //         fontSize: '10'
  //       }}
  //     />
  //   );
  // };





  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF",
      fontSize: "1.5rem"
    }
  })(Typography);

  // const CategoryTypography = withStyles({
  //   root: isMobile ?
  //     {
  //       color: "#FFFFFF",
  //       fontSize: '1rem',
  //     }
  //     :
  //     {
  //       color: "#FFFFFF",
  //       fontSize: '1.2rem',
  //     }
  // })(Typography);

  const ButtonTypography = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.5rem',
      }
  })(Typography);





  return (
    <div>
      <Dialog fullScreen={isMobile ? true : false} classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCoinExchangeProposeDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
            <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
              <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
              <WhiteTextTypography >ExChange</WhiteTextTypography>
            </Grid>
            <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
              <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CoinExchangeProposeFalse") }} />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' paddingLeft="0px" position='sticky' top={0} >
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
              <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20, backgroundColor: isBTC === true ? "#66bb6a" : "" }
                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20, backgroundColor: isBTC === true ? "#66bb6a" : "" }}
                variant="contained" color='inherit' onClick={(e) => { CoinExchangeStore?.setBTCOpen(true) }} >
                <ButtonTypography>
                  BTC
                </ButtonTypography>
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
              <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20, backgroundColor: isUSTD === true ? "#66bb6a" : "" }
                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20, backgroundColor: isUSTD === true ? "#66bb6a" : "" }}
                variant="contained" color='inherit' onClick={(e) => { CoinExchangeStore?.setUSTDOpen(true) }} >
                <ButtonTypography>
                  USTD
                </ButtonTypography>
              </Button>
            </Grid>
            {/* <Grid item xs={4} sm={4} md={4} lg={4} xl={4} /> */}
            {/* <Grid item xs={4} sm={4} md={4} lg={4} xl={4} >
              <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                variant="contained" color='inherit' onClick={(e) => { loginStore.setDBMiningButton(2) }} >TEST</Button>
            </Grid> */}
          </Grid>
        </Box>

        <DialogContent >
          {/* {
            isBTC === true ?
              <ExchangePage />
              :
              <div>
              </div>
          } */}
              <ExchangePage />




        </DialogContent>

      </Dialog>
    </div >
  );
};

export default observer(CoinExchangePropose);


